/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type TrainingDefinitionAssignmentDto = {
    createdBy?: string;
    createdDate?: string;
    lastModifiedBy?: string;
    lastModifiedDate?: string;
    deleted?: boolean;
    id?: string;
    trainingDefinitionId?: string;
    referenceTableId?: string;
    assignmentTypeDefinition?: TrainingDefinitionAssignmentDto.assignmentTypeDefinition;
}

export namespace TrainingDefinitionAssignmentDto {

    export enum assignmentTypeDefinition {
        LOCATION = 'LOCATION',
        DEPARTMENT = 'DEPARTMENT',
        WORKSTATION = 'WORKSTATION',
        COMPANY = 'COMPANY',
        POSITION = 'POSITION',
        EMPLOYEE = 'EMPLOYEE',
    }


}
